import axios from "axios";
import $form from "./form";
import $http from "./http";
import $list from "./list";
import $token from "./token";
import $upload from "./upload";

const map = {
  $form, $http, $list, $token, $upload,
};

const mapUtilsList = (
  moduleName,
  list,
) => Object.keys(map[`$${moduleName}`])
  .reduce((acc, key) => {
    const isExist = list.includes(key);

    return isExist
      ?
      { ...acc, [`$${moduleName}_${key}`]: map[`$${moduleName}`][key] }
      :
      acc;
  }, {});

const mapUtilsTable = (
  moduleName,
  table,
) => {
  const list = Object.entries(table);

  Object.keys(map[`$${moduleName}`])
    .reduce((acc, key) => {
      const target = list.find(item => item[1] === key);

      return target
        ?
        { ...acc, [`$${moduleName}_${target[0]}`]: map[`$${moduleName}`][key] }
        :
        acc;
    }, {});
};

const mapUtils = (
  moduleName,
  detail,
) => {
  if (typeof detail !== "object") {
    throw new Error("mapUtils报错：detail参数不为对象");
  }

  return detail instanceof Array
    ? mapUtilsList(moduleName, detail)
    : mapUtilsTable(moduleName, detail);
};

export default mapUtils;
const apiMapSaas = {
  localhost: "https://final-admin-api.caihonggou.com",
  "127.0.0.1": "https://final-admin-api.caihonggou.com",
  "192.168.0.146": "https://final-admin-api.caihonggou.com",
  "final-courseware-vue.caihonggou.com": "https://final-admin-api.caihonggou.com/",
  "final-courseware.aikaola.com": "https://final-admin-api.aikaola.com/",
};
const previewMap = {
  localhost: "https://final-activity.caihonggou.com/appH5/#/listenPreview",
  "127.0.0.1": "https://final-activity.caihonggou.com/appH5/#/listenPreview",
  "192.168.8.99": "https://final-activity.caihonggou.com/appH5/#/listenPreview",
  "final-courseware-vue.caihonggou.com": "https://final-activity.caihonggou.com/appH5/#/listenPreview",
  "final-courseware.aikaola.com": "https://final-activity.caihonggou.com/wechatApp/#/listenPreview",
};
const previewGameMap = {
  localhost: "https://oa-statics.caihonggou.com/courseware_test/web-mobile/index.html",
  "192.168.8.124": "https://oa-statics.caihonggou.com/courseware_test/web-mobile/index.html",
  "final-courseware-vue.caihonggou.com": "https://oa-statics.caihonggou.com/courseware_test/web-mobile/index.html",
  "final-courseware.aikaola.com": "https://oa-statics.caihonggou.com/courseware/web-mobile/index.html",
};

export const baseURISaas = apiMapSaas[window.location.hostname];
export const previewUrl = previewMap[window.location.hostname];
export const previewGameUrl = previewGameMap[window.location.hostname];


export { $form, $http, $list, $token, $upload };
// export const apiMapSaas = {
//   localhost: "https://final-admin-api.caihonggou.com",
//   "192.168.8.124": "https://final-admin-api.caihonggou.com",
//   "final-courseware-vue.caihonggou.com": "https://final-admin-api.caihonggou.com/",
//   "final-courseware.aikaola.com": "https://final-admin-api.aikaola.com/",
// };
// export const baseURISaas = apiMapSaas[window.location.hostname];
export const axiosRequest = {
  get(url, data) {
    const baseUrl = baseURISaas;
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: `${baseUrl}${url}`,
        params: {
          ...data,
        },
        headers: {
          Authorization: `Bearer ${$token.get()}`,
        },
      })
        .then((obj) => {
          if (obj.status == 200) {
            resolve(obj.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post(url, data) {
    const baseUrl = baseURISaas;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: `${baseUrl}${url}`,
        data: {
          ...data,
        },
        headers: {
          Authorization: `Bearer ${$token.get()}`,
        },
      })
        .then((obj) => {
          if (obj.status === 200) {
            resolve(obj);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delete(url, data) {
    const baseUrl = baseURISaas;
    return new Promise((resolve, reject) => {
      axios({
        method: "DELETE",
        url: `${baseUrl}${url}`,
        data: {
          ...data,
        },
        headers: {
          Authorization: `Bearer ${$token.get()}`,
        },
      })
        .then((obj) => {
          if (obj.status === 200) {
            resolve(obj);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  put(url, data) {
    const baseUrl = baseURISaas;
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: `${baseUrl}${url}`,
        data: {
          ...data,
        },
        headers: {
          Authorization: `Bearer ${$token.get()}`,
        },
      })
        .then((obj) => {
          if (obj.status === 200) {
            resolve(obj);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
